export const DEMAND_ANALYSIS_HOME_STATE_NAME = "digitalsuite_marketresearch_keywordmarketanalysis_home_31";

export const TOPICS_HEATMAP_STATE_NAME = "digitalsuite_marketresearch_keywordmarketanalysis_topics_heatmap";
